import bomateLifecycleAvatar from '../../assets/scenario-icons/bocoder/bomate-lifecycle.jpg';
import industryAnalysisAvatar from '../../assets/scenario-icons/bocoder/industry-analysis.jpg';
import investmentModelingAvatar from '../../assets/scenario-icons/bocoder/investment-modeling.jpg';
import learningAssistantAvatar from '../../assets/scenario-icons/bocoder/learning-assistant.jpg';
import marketLiquidityAvatar from '../../assets/scenario-icons/bocoder/market-liquidity.jpg';
import pcAssistantAvatar from '../../assets/scenario-icons/bocoder/pc-assistant.jpg';
import socialMediaAssistantAvatar from '../../assets/scenario-icons/bocoder/social-media-assistant.jpg';
import steelIntelligenceAvatar from '../../assets/scenario-icons/bocoder/steel-intelligence.jpg';
import videoCreativeAvatar from '../../assets/scenario-icons/bocoder/video-creative.jpg';
import type { MyScenario } from '../../services/scenario';

const AVATAR_BY_FILE_NAME: Record<string, string> = {
  '1787218647362551741.jpg': socialMediaAssistantAvatar,
  '1787280738917008698.jpg': industryAnalysisAvatar,
  '1787280770444431351.jpg': pcAssistantAvatar,
  '1787280800644336099.jpg': marketLiquidityAvatar,
  '1787280822381031676.jpg': videoCreativeAvatar,
  '1787280843460888067.jpg': steelIntelligenceAvatar,
  '1787280871911084263.jpg': learningAssistantAvatar,
  '1787280897157966513.jpg': investmentModelingAvatar,
  '1787280917864632233.jpg': bomateLifecycleAvatar,
};

const AVATAR_BY_SCENARIO_NAME: Record<string, string> = {
  自媒体助手: socialMediaAssistantAvatar,
  行业分析专家: industryAnalysisAvatar,
  PC电脑助手: pcAssistantAvatar,
  市场流动性分析报告: marketLiquidityAvatar,
  视频创意: videoCreativeAvatar,
  钢铁产业情报: steelIntelligenceAvatar,
  学习助手: learningAssistantAvatar,
  投资建模与专业交付专家: investmentModelingAvatar,
  BoMate全生命周期投资总控专家: bomateLifecycleAvatar,
};

/** 兼容平台历史上传文件名；只用于内置素材索引，不发起网络请求。 */
const getIconFileName = (icon: string): string => {
  if (!icon) return '';
  try {
    const pathname = new URL(icon, 'https://scenario-avatar.local').pathname;
    return pathname.split('/').pop()?.toLowerCase() || '';
  } catch {
    return '';
  }
};

/** 返回与 BoMate 相同的九个内置头像；远端图片不可用时供列表/详情/输入框回退。 */
export const getBundledScenarioAvatar = (scenario: MyScenario): string | null =>
  AVATAR_BY_FILE_NAME[getIconFileName(scenario.icon?.trim() || '')] ||
  AVATAR_BY_SCENARIO_NAME[scenario.name?.trim() || ''] ||
  null;
